export default __webpack_public_path__ + "static/media/important_icon.7f091f61.png";